import React, { useState } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import Iconify from 'src/components/Iconify';
import {
    CHATS_ARQUIVADAS_DESIGN as D,
    getCorAvatar,
    getIniciais
} from './ChatsArquivadas.design';

const formatarData = (valor) => {
    if (!valor) return '';
    const data = new Date(valor);
    if (Number.isNaN(data.getTime())) return '';
    return data.toLocaleDateString('pt-BR');
};

const formatarTelefone = (numero) => {
    if (!numero) return '';
    const digitos = `${numero}`.replace(/\D/g, '');
    const semPais = digitos.startsWith('55') ? digitos.slice(2) : digitos;
    if (semPais.length < 10) return numero;
    const ddd = semPais.slice(0, 2);
    const resto = semPais.slice(2);
    const meio = resto.length > 8 ? resto.slice(0, 5) : resto.slice(0, 4);
    const fim = resto.length > 8 ? resto.slice(5) : resto.slice(4);
    return `(${ddd}) ${meio}-${fim}`;
};

export default function ArquivoCard({ chat, index, onAbrir, onDesarquivar }) {
    const [menuAberto, setMenuAberto] = useState(false);
    const chatId = `${chat._id}`;

    const handleAcao = (evento, acao) => {
        evento.stopPropagation();
        setMenuAberto(false);
        acao();
    };

    return (
        <Draggable draggableId={chatId} index={index}>
            {(provided, snapshot) => (
                <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    onClick={() => onAbrir(chat)}
                    className={`${D.card.container} ${snapshot.isDragging ? D.card.containerDragging : ''}`}
                >
                    <div className={D.card.header}>
                        <div
                            className={D.card.avatar}
                            style={{ backgroundColor: getCorAvatar(chat.nomeCliente) }}
                        >
                            {getIniciais(chat.nomeCliente)}
                        </div>

                        <div className="min-w-0 flex-1">
                            <div className="flex items-center gap-1.5">
                                <p className={D.card.name}>{chat.nomeCliente || 'Sem nome'}</p>
                                {chat.novaMensagem === 'sim' && <span className={D.card.unread} />}
                            </div>
                            <p className={D.card.message}>{chat.lastMessage || 'Sem mensagens'}</p>
                        </div>

                        <div className="relative">
                            <button
                                type="button"
                                className={D.card.menu}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setMenuAberto((atual) => !atual);
                                }}
                            >
                                <Iconify icon="eva:more-vertical-fill" width={12} />
                            </button>

                            {menuAberto && (
                                <>
                                    <div
                                        className="fixed inset-0 z-10"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setMenuAberto(false);
                                        }}
                                    />
                                    <div className="absolute right-0 top-6 z-20 w-44 bg-white rounded-xl border border-gray-100 shadow-lg py-1">
                                        <button
                                            type="button"
                                            className="w-full flex items-center gap-2 px-3 py-2 text-xs text-gray-600 hover:bg-gray-50 transition-colors"
                                            onClick={(e) => handleAcao(e, () => onAbrir(chat))}
                                        >
                                            <Iconify icon="eva:message-circle-outline" width={14} />
                                            Abrir conversa
                                        </button>
                                        <button
                                            type="button"
                                            className="w-full flex items-center gap-2 px-3 py-2 text-xs text-[#7C3AED] hover:bg-violet-50 transition-colors"
                                            onClick={(e) => handleAcao(e, () => onDesarquivar(chat))}
                                        >
                                            <Iconify icon="eva:undo-outline" width={14} />
                                            Desarquivar
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>

                    <div className={D.card.footer}>
                        <span className={D.card.date}>
                            {formatarData(chat.arquivado_em || chat.dataUltimaMensagem)}
                        </span>
                        {chat.numeroCliente && (
                            <span className={D.card.phone}>
                                <Iconify icon="ic:round-whatsapp" width={10} />
                                {formatarTelefone(chat.numeroCliente)}
                            </span>
                        )}
                    </div>
                </div>
            )}
        </Draggable>
    );
}
